import { BettoSadFaceIcon } from "@layouts/betto/shared/BettoSadFaceIcon";
import PropTypes from "prop-types";
import React, { memo } from "react";
import { EmptyStateIcon, EmptyStateRoot, EmptyStateTitle } from "./elements";

export const BettoEmptyState = memo(({ title, icon, children }) => (
	<EmptyStateRoot>
		<EmptyStateIcon>{icon || <BettoSadFaceIcon />}</EmptyStateIcon>
		<EmptyStateTitle>{title}</EmptyStateTitle>
		{children}
	</EmptyStateRoot>
));

BettoEmptyState.displayName = "BettoEmptyState";

BettoEmptyState.propTypes = {
	title: PropTypes.string.isRequired,
	icon: PropTypes.node,
	children: PropTypes.node,
};
